
import { defineComponent } from "vue";
import { getFirestore, collection, getDocs, CollectionReference, query, orderBy, limit } from "firebase/firestore"

interface ComponentData {
  showModal: boolean,
  submissionsRef: CollectionReference | null,
  leaderboard: {
    id: string;
    playerName: string;
    score: number;
  }[]
}

export default defineComponent({
  name: "LeaderboardPopup",
  data: (): ComponentData => ({
    showModal: false,
    submissionsRef: null,
    leaderboard: []
  }),
  methods: {
    async fetchLeaderboard() {
      if (!this.submissionsRef) {
        return;
      }
      this.leaderboard = [];
      const q = query(this.submissionsRef, orderBy("score", "desc"), limit(20));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        const docData = doc.data();
        this.leaderboard.push({
          id: doc.id,
          playerName: docData.playerName,
          score: docData.score,
        })
      });
    }
  },
  mounted() {
    const db = getFirestore();
    this.submissionsRef = collection(db, "submissions");
    this.fetchLeaderboard();
    window.showOrHideLeaderboardPopup = (show: boolean) => {
      this.showModal = show;
      if (show) {
        this.fetchLeaderboard();
      }
    }
  }
});
